module.exports = __webpack_public_path__ + "2bd7258349ec53bcc771f4c1dffab31c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/船.jpg
// module id = cLEB
// module chunks = 1 6